import React, { useEffect } from "react";
import {
  Modal,
  Form,
  Radio,
  InputNumber,
  Input,
  Typography,
  Space,
} from "antd";
import dayjs from "dayjs";

const { Text } = Typography;
const { TextArea } = Input;

// ✅ ผลการขาย — single source of truth
export const SALE_RESULT = {
  SOLD: 1, // ราคาขาย (ขายได้)
  WITHHELD: 2, // งดการขาย
  CANCELLED: 3, // ยกเลิกการขาย
  NO_SOLD: 4,
};

export const SALE_RESULT_META = {
  [SALE_RESULT.SOLD]: { label: "ราคาขาย", color: "green" },
  [SALE_RESULT.WITHHELD]: { label: "งดการขาย", color: "orange" },
  [SALE_RESULT.CANCELLED]: { label: "ยกเลิกการขาย", color: "red" },
  [SALE_RESULT.NO_SOLD]: { label: "ไม่มีผู้สู้ราคา", color: "default" },
};

const SaleResultModal = ({
  open,
  round,
  date,
  initialResult,
  onClose,
  onConfirm,
}) => {
  const [form] = Form.useForm();
  const resultType = Form.useWatch("resultType", form);

  // ✅ เซ็ตค่าเริ่มต้นทุกครั้งที่เปิด (ถ้ามีผลเดิมให้แก้ไขต่อ)
  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        resultType: initialResult?.resultType ?? SALE_RESULT.SOLD,
        price: initialResult?.price ?? null,
        reason: initialResult?.reason ?? "",
      });
    }
  }, [open, initialResult, form]);

  const handleOk = async () => {
    const values = await form.validateFields();
    const isSold = values.resultType === SALE_RESULT.SOLD;
    onConfirm({
      resultType: values.resultType,
      price: isSold ? Number(values.price) : null,
      reason: isSold ? "" : values.reason || "",
    });
    onClose();
  };

  return (
    <Modal
      title={`บันทึกผลการขาย — นัดที่ ${round ?? "-"}`}
      open={open}
      onCancel={onClose}
      onOk={handleOk}
      okText="บันทึกผล"
      cancelText="ยกเลิก"
      destroyOnHidden
      width={460}
    >
      <Text type="secondary">
        วันนัดขาย:{" "}
        {date ? dayjs(date).add(543, "year").format("D MMM YYYY") : "-"}
      </Text>

      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item
          label="ผลการขาย"
          name="resultType"
          rules={[{ required: true, message: "กรุณาเลือกผลการขาย" }]}
        >
          <Radio.Group>
            <Space direction="vertical">
              <Radio value={SALE_RESULT.NO_SOLD}>ไม่มีผู้สู้ราคา</Radio>
              <Radio value={SALE_RESULT.SOLD}>ราคาขาย (ขายได้)</Radio>
              <Radio value={SALE_RESULT.WITHHELD}>งดการขาย</Radio>
              <Radio value={SALE_RESULT.CANCELLED}>ยกเลิกการขาย</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>

        {resultType === SALE_RESULT.SOLD ? (
          <Form.Item
            label="ราคาขาย (บาท)"
            name="price"
            rules={[
              { required: true, message: "กรุณาระบุราคาขาย" },
              { type: "number", min: 0, message: "ราคาต้องไม่ติดลบ" },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              placeholder="ระบุราคาขาย"
              formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              parser={(v) => v.replace(/,/g, "")}
            />
          </Form.Item>
        ) : (
          <Form.Item
            label="เหตุผล"
            name="reason"
            rules={[{ required: true, message: "กรุณาระบุเหตุผล" }]}
          >
            <TextArea
              rows={3}
              placeholder="ระบุเหตุผล"
              maxLength={300}
              showCount
            />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default SaleResultModal;
